import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { notePathChange } from "@/lib/analytics-enhanced";

/** Remembers the page before this one, for `pricing_view`'s `from`. */
export function RouteHistory() {
  const { pathname } = useLocation();

  useEffect(() => {
    notePathChange(pathname);
  }, [pathname]);

  return null;
}
